import React, { useState, useEffect } from "react";
import { TextField, Typography } from "@mui/material";
import dayjs from "dayjs";

const RequirementDetailsView = ({
  requirement,
  productList,
  allProductMaster,
}) => {
  const [displayValues, setDisplayValues] = useState({});

  useEffect(() => {
    if (requirement) {
      // Find product details
      const productDetails = allProductMaster.find(
        (item) => item.ProductID === requirement.ProductID
      );

      // Parse delivery location
      const deliveryLocationParts =
        requirement.DeliveryLocation?.split("~") || [];
      const destination = deliveryLocationParts[0] || "";
      const deliveryPort = deliveryLocationParts[1] || "";

      // Parse packaging details
      let packaging = "";
      if (requirement.ProductPackaging) {
        try {
          const jsonLike = requirement.ProductPackaging.replace(/{|}/g, "")
            .split(",")
            .map((part) => part.split("="))
            .reduce((obj, [key, value]) => {
              obj[key?.trim()] = value ? value.trim() : "";
              return obj;
            }, {});
          packaging = jsonLike.item || "";
        } catch (error) {
          packaging = requirement.ProductPackaging;
        }
      }

      // Format dates
      const deliveryStart = requirement.DeliveryPeriodFrom
        ? dayjs(requirement.DeliveryPeriodFrom).format("DD-MM-YYYY")
        : "";
      const deliveryEnd = requirement.DeliveryPeriodTill
        ? dayjs(requirement.DeliveryPeriodTill).format("DD-MM-YYYY")
        : "";
      const validUntil = requirement.ValidUntil
        ? dayjs(requirement.ValidUntil).format("DD-MM-YYYY")
        : "";

      setDisplayValues({
        product: productDetails?.ProductName || "",
        grade: productDetails?.Grade || "",
        origin: requirement.OriginCountry || "",
        destination: destination,
        quantity: requirement.Quantity || "",
        incoTerms: requirement.Incoterm || "",
        paymentTerms: requirement.PaymentTerms || "",
        packaging: packaging,
        deliveryPort: deliveryPort,
        deliveryStart: deliveryStart,
        deliveryEnd: deliveryEnd,
        validUntil: validUntil,
      });
    }
  }, [requirement, allProductMaster]);

  if (!requirement) {
    return <div>No requirement data available</div>;
  }

  return (
    <div className="requirement-details-view">
      <div className="row">
        <div className="col-md-3">
          <div className="mb-3">
            <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
              Product *
            </Typography>
            <TextField
              value={displayValues.product}
              fullWidth
              size="small"
              InputProps={{
                readOnly: true,
              }}
              sx={{ backgroundColor: "#f8f9fa" }}
            />
          </div>
        </div>
        <div className="col-md-3">
          <div className="mb-3">
            <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
              Grade *
            </Typography>
            <TextField
              value={displayValues.grade}
              fullWidth
              size="small"
              InputProps={{
                readOnly: true,
              }}
              sx={{ backgroundColor: "#f8f9fa" }}
            />
          </div>
        </div>
        <div className="col-md-3">
          <div className="mb-3">
            <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
              Origin *
            </Typography>
            <TextField
              value={displayValues.origin}
              fullWidth
              size="small"
              InputProps={{
                readOnly: true,
              }}
              sx={{ backgroundColor: "#f8f9fa" }}
            />
          </div>
        </div>
        <div className="col-md-3">
          <div className="mb-3">
            <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
              Destination *
            </Typography>
            <TextField
              value={displayValues.destination}
              fullWidth
              size="small"
              InputProps={{
                readOnly: true,
              }}
              sx={{ backgroundColor: "#f8f9fa" }}
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-3">
          <div className="mb-3">
            <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
              Quantity (MT) *
            </Typography>
            <TextField
              value={displayValues.quantity}
              fullWidth
              size="small"
              InputProps={{
                readOnly: true,
              }}
              sx={{ backgroundColor: "#f8f9fa" }}
            />
          </div>
        </div>
        <div className="col-md-3">
          <div className="mb-3">
            <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
              Inco Terms
            </Typography>
            <TextField
              value={displayValues.incoTerms}
              fullWidth
              size="small"
              InputProps={{
                readOnly: true,
              }}
              sx={{ backgroundColor: "#f8f9fa" }}
            />
          </div>
        </div>
        <div className="col-md-3">
          <div className="mb-3">
            <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
              Payment Terms
            </Typography>
            <TextField
              value={displayValues.paymentTerms}
              fullWidth
              size="small"
              InputProps={{
                readOnly: true,
              }}
              sx={{ backgroundColor: "#f8f9fa" }}
            />
          </div>
        </div>
        <div className="col-md-3">
          <div className="mb-3">
            <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
              Packaging
            </Typography>
            <TextField
              value={displayValues.packaging}
              fullWidth
              size="small"
              InputProps={{
                readOnly: true,
              }}
              sx={{ backgroundColor: "#f8f9fa" }}
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-3">
          <div className="mb-3">
            <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
              Delivery Port
            </Typography>
            <TextField
              value={displayValues.deliveryPort}
              fullWidth
              size="small"
              InputProps={{
                readOnly: true,
              }}
              sx={{ backgroundColor: "#f8f9fa" }}
            />
          </div>
        </div>
        <div className="col-md-3">
          <div className="mb-3">
            <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
              Delivery (Start) *
            </Typography>
            <TextField
              value={displayValues.deliveryStart}
              fullWidth
              size="small"
              InputProps={{
                readOnly: true,
              }}
              sx={{ backgroundColor: "#f8f9fa" }}
            />
          </div>
        </div>
        <div className="col-md-3">
          <div className="mb-3">
            <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
              Delivery (End) *
            </Typography>
            <TextField
              value={displayValues.deliveryEnd}
              fullWidth
              size="small"
              InputProps={{
                readOnly: true,
              }}
              sx={{ backgroundColor: "#f8f9fa" }}
            />
          </div>
        </div>
        <div className="col-md-3">
          <div className="mb-3">
            <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
              Valid Until *
            </Typography>
            <TextField
              value={displayValues.validUntil}
              fullWidth
              size="small"
              InputProps={{
                readOnly: true,
              }}
              sx={{ backgroundColor: "#f8f9fa" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequirementDetailsView;
